import {InjectionToken} from '@angular/core';

export const PLATFORM: InjectionToken<string> = new InjectionToken<string>('device:info:platform');
